export const FACE_APPROVAL_REQUEST = "FACE_APPROVAL_REQUEST";
export const FACE_APPROVAL_SUCCESS = "FACE_APPROVAL_SUCCESS";
export const FACE_APPROVAL_FAILED = "FACE_APPROVAL_FAILED";
